import React from "react";
import { Button } from "@mui/material";

export default function BlueOutlinedSmallButton({
  startIcon,
  buttonTitle,
  onClick,
  endIcon
}) {
  return (
    <Button
      variant="outlined"
      startIcon={startIcon ? startIcon : ""}
      onClick={onClick}
      endIcon={endIcon}
      sx={{
        borderRadius: "6px",
        fontSize: "14px",
        fontWeight: 700,
        height: "30px",
        textTransform: "none",
        border:"1px solid #572575",
        color: "#572575",
        px: 3,
        fontFamily:"Inter",
        "&:hover" :{
         border:"1px solid #572575",
        }
       
      }}
    >
      {buttonTitle}
    </Button>
  );
}
